<div class="container container-auth"> 
    <div class="vertical-aling-out">
        <div class="vertical-aling-inner">
            <img class="logo-auth" src="assets/images/logo-ats.png" alt="Logo ATS" />
            <div class="google-container">
                <asl-google-signin-button type="standard" size="large" [width]="330"> </asl-google-signin-button>         
            </div>
        </div>
    </div>
  </div>